import { l10n } from '../i18n/i18nUtil';
export var appAuthorizationCheck = function (user, appId, allowedAccessMap) {
    if (user.authorities.length === 0 ||
        user.authorities.some(function (a) { return a === 'SUPPORT_USER'; })) {
        return {
            allowed: false,
            errorMessage: l10n('util.noAccess')
        };
    }
    else if (allowedAccessMap["core.app." + appId] &&
        !(
        // authzn is allowed for VCF_USER users with vcfadmin@local user only.
        (appId === 'authzn' &&
            user.authorities.some(function (a) { return a === 'VCF_USER'; }) &&
            user.name !== 'vcfadmin@local'))) {
        return {
            allowed: true
        };
    }
    else {
        return {
            allowed: false,
            errorMessage: l10n('util.noPrivilage')
        };
    }
};
export var filterLcmApps = function (user, apps, allowedAccessMap) {
    return apps
        .filter(function (app) {
        return appAuthorizationCheck(user, app.vmid, allowedAccessMap)
            .allowed;
    })
        .slice()
        .sort(function (a, b) {
        return typeof a.accessOrder === 'number' && typeof b.accessOrder === 'number'
            ? a.accessOrder - b.accessOrder
            : -1;
    });
};
